<div class="flex flex-col flex-1 px-2 py-2" data-testid="selectedAuthor">
  <div class="flex flex-col flex-1">
    <div class="flex justify-between flex-1">
      <span>{{ selectedAuthor?.name }}</span>
      <div class="space-x-1">
        <button
          type="button"
          class="text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-3600"
          data-testid="refreshAuthorBtn"
          title="Refresh author"
          (click)="refreshAuthor(selectedAuthor)"
        >
          <i class="icon icon-refresh"></i>
        </button>
        <button
          type="button"
          class="text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-2700"
          data-testid="selectedAuthorDeleteBtn"
          title="Remove author"
          (click)="removeAuthor(selectedAuthor)"
        >
          <i class="icon icon-minus-circle"></i>
        </button>
      </div>
    </div>
    <div
      class="flex justify-between flex-1 p-1 text-xs"
      [ngClass]="{
        'bg-project-2500': isEditingLocation
      }"
    >
      <span *ngIf="selectedAuthor?.location && !isEditingLocation">
        {{ selectedAuthor?.location }}</span
      >
      <div *ngIf="isEditingLocation">
        <input
          type="text"
          matInput
          [formControl]="authorLocationInput"
          placeholder="Location"
          (keyup.enter)="updateSelectedAuthorLocation(selectedAuthor)"
          (blur)="updateSelectedAuthorLocation(selectedAuthor)"
        />
      </div>
      <div *ngIf="!isEditingLocation">
        <a (click)="isEditingLocation = !isEditingLocation"
          >(<span
            *ngIf="selectedAuthor?.location"
            class="hover:text-project-2100"
            >change location</span
          >
          <span
            *ngIf="!selectedAuthor?.location"
            class="hover:text-project-2100"
            >set location</span
          >)</a
        >
      </div>
    </div>
  </div>
</div>
